import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  MakeChoiceHeading,
  MakeChoiceFeature,
  TableRow1,
  TableRow2,
  TableRow3,
  TableRow4,
  TableRow5,
  TableRow6,
  TableRow7,
} from '../../Constants';
import { Icon } from '../elements/icon';
import { logo_home } from '../../Data/Images/Home';
import RiisePouch from '../../assets/yellow-paper-pouch-granules.webp';
import MakeChoiceHeader from '../../assets/make-choice-header.png';

const MakeChoice = ({ isProductPage }) => {
  const { t } = useTranslation();

  const DATA = [
    { feature: t(TableRow1), bioniq: true, others: false },
    { feature: t(TableRow2), bioniq: true, others: false },
    { feature: t(TableRow3), bioniq: true, others: false },
    { feature: t(TableRow4), bioniq: true, others: false },
    { feature: t(TableRow6), bioniq: true, others: false },
    { feature: t(TableRow7), bioniq: true, others: false },
  ];

  return (
    <div className="t-flex t-flex-col t-gap-4 t-py-4">
      <h2 className="t-text-center !t-m-0 t-font-serif t-font-normal t-text-navy">
        {t(MakeChoiceHeading)}
      </h2>

      <div className="t-rounded-xl t-border t-border-g200 t-overflow-hidden">
        <table className="t-border-collapse t-w-full t-bg-white">
          <thead>
            <tr className="t-border-b t-border-g200">
              <th className="t-p-3 t-text-left t-font-sans t-text-[13px] t-font-semibold t-text-navy/60 t-w-[55%]">
                {t(MakeChoiceFeature)}
              </th>
              <th className="t-p-3 t-text-center t-bg-quiz-teal/[.06] t-border-l t-border-g200 t-w-[22.5%]">
                <div className="t-flex t-items-center t-justify-center t-gap-1">
                  <img src={logo_home} alt="riise" height={26} width={34} />
                  <img src={RiisePouch} alt="" height={26} width={13} />
                </div>
              </th>
              <th className="t-p-3 t-text-center t-border-l t-border-g200 t-w-[22.5%]">
                <img src={MakeChoiceHeader} alt="others" height={28} width={42} className="t-mx-auto" />
              </th>
            </tr>
          </thead>
          <tbody>
            {DATA.map((row, index) => (
              <tr key={index} className="t-border-t t-border-g200">
                <td className="t-p-3 t-font-sans t-text-[14px] t-font-medium t-text-navy">
                  {row.feature}
                </td>
                <td className="t-p-3 t-text-center t-bg-quiz-teal/[.06] t-border-l t-border-g200">
                  <Icon name="tealCheckCircle" size={20} />
                </td>
                <td className="t-p-3 t-text-center t-border-l t-border-g200">
                  <Icon name="cross" size={20} color="#BDBDBD" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MakeChoice;
